export default __webpack_public_path__ + "static/media/snowTut.e50364cb.png";